'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useMemo, useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';
import AdSlot from '@/app/[locale]/(worlds)/[roomId]/components/AdSlot';
import { getMultisizeMBAdSizes } from '@/constants/ad';
import { usePlatformAdFree } from '@/hooks/usePlatformAdFree';
import { env } from '@/lib/runtime-env';
function MobileContentDetailBannerAd() {
  const $ = _c(7);
  const containerRef = useRef(null);
  const {
    isAdFree
  } = usePlatformAdFree();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ref: containerRef as RefObject<HTMLElement>,
      box: "border-box"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    width: t1
  } = useResizeObserver(t0);
  const width = t1 === undefined ? 0 : t1;
  let t2;
  if ($[1] !== width) {
    t2 = getMultisizeMBAdSizes(width);
    $[1] = width;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const eligibleAdSizes = t2;
  if (isAdFree) {
    return null;
  }
  let t3;
  if ($[3] !== eligibleAdSizes) {
    t3 = eligibleAdSizes.length > 0 && <AdSlot adSurface="mobile-content-detail-banner" gamAdUnitPath={env("NEXT_PUBLIC_GAM_MULTISIZE_MB_AD_UNIT_PATH")} sizes={eligibleAdSizes} contentClassName="mx-auto" />;
    $[3] = eligibleAdSizes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div ref={containerRef} data-component="mobile-content-detail-banner-ad" className="w-full px-4">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export default MobileContentDetailBannerAd;